/*
 * File: d:\projects\AutoFiFront\src\Content\AboutUs\Engagements\EngagementAboutUs.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday April 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday April 17th 2023 4:08:11 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { ReactNode } from 'react';
import styles from 'Content/AboutUs/Engagements/EngagementAboutUs.module.css';
import translator from 'MultiLanguage/TranslationWrapper';

type EngagementAboutUsProps = {
    title?: string,
    text: string[],
    icon?: ReactNode
};

function EngagementAboutUs(props: EngagementAboutUsProps) {
    return (
        <React.Fragment>
            <div className={`${styles.engagementHolder}`}>
                {props.title ?
                    <div className={`${styles.titleSection}`}>
                        <h3 className={`${styles.title}`}>
                            {translator.decode(props.title)}
                        </h3>
                        <div className={`${styles.line}`}></div>
                        <div className={`${styles.iconEngagement}`}>
                            {props.icon}
                        </div>
                    </div>
                    :null
                }
                <div className={`${styles.textEngagement}`}>
                    {props.text.map((text,index)=>{return <p key={6546465+index}> {translator.decode(`${text}`)} </p>})}
                </div>
            </div>
        </React.Fragment>
    )
}

export default EngagementAboutUs;
